export default __webpack_public_path__ + "static/media/art-brw-4.b35b9b06.png";